module.exports = __webpack_public_path__ + "img/americanfootball.bd4fc301.svg";